<template>
  <div>
    <div @click="onCalendar" v-if="$slots.default">
      <slot  />
    </div>
    <ButtonBase
      v-bind="button"
      @click="onCalendar"
      v-else-if="type == 'button'"
    >
      <IconBase name="cute/calendar" class="mr-1.5" :width="18" /> {{ $t('components.Event.actions.calendar') }}
    </ButtonBase>
    <add-to-calendar-button
      v-bind="attrs"
      options="'Apple','Google','iCal','Outlook.com','Yahoo'"
      class="inline-block"
      buttonsList
      hideTextLabelButton
      buttonStyle="round"
      lightMode="bodyScheme"
      v-else
    />
  </div>
</template>

<script lang="ts" setup>
import { atcb_action } from 'add-to-calendar-button'
import { Event } from '@/classes'
import PlacesStore from '@/store/places'
import dayjs from 'dayjs'
  
const props = withDefaults(defineProps<{
  event: Event,
  button?: any
  type?: 'button' | 'buttons'
}>(), {
  type: 'button',
  button: {
    color: 'royal',
    size: 'xs',
    isFull: true
  }
})

const { event } = toRefs(props)

const placesStore = PlacesStore()

const place = computed(() => placesStore.getItem(event.value.place ?? ''))
const route = useRoute()

const attrs = computed(() => {
  if (!event?.value) return {}

  let description = event.value.description

  if (event.value.warning) description = '⚠️ ' + event.value.warning + '[br][br]' + description
  if (event.value.timing) description = '🕓 ' + event.value.timing + '[br][br]' + description

  description += '[br][br][url]' + event.value.shareLinks.app + '|' + event.value.shareLinks.app + '[/url]'

  useNuxtApp().$amplitude.logEvent(`Event_CalendarAdd`, {
    source: route.fullPath
  })

  return {
    name: event.value.title + ' @ ' + (event.value.type === 'online' ? useNuxtApp().$i18n.t('components.Event.online.label') : (place.value?.name ?? '')),
    description,
    ...(place.value && event.value.type !== 'online' ? {
      location: `${place.value?.name}, ${nl2a(place.value?.address, ', ')}`
    } : {}),

    startDate: dayjs(event.value.date).format('YYYY-MM-DD'),
    startTime: dayjs(event.value.date).format('HH:mm'),
    endDate: dayjs(event.value.date).add(5, 'hours').format('YYYY-MM-DD'),
    endTime: dayjs(event.value.date).add(5, 'hours').format('HH:mm'),
    
    options: ['Google', 'Apple', 'iCal'],
    language: 'fr',
    availability: 'busy',
    timeZone: 'Europe/Paris'
  }
})

const onCalendar = () => {
  atcb_action(attrs.value)
}
</script>